import { NgModule } from '@angular/core';
import { LoaderDisablesFormGroupDirective } from './loader-disables-form-group.directive';

/** The LoaderDisablesFormGroupDirective module, used to improve tree shaking. */
@NgModule({
    declarations: [ LoaderDisablesFormGroupDirective ],
    exports: [ LoaderDisablesFormGroupDirective ]
})
export class LoaderDisablesFormGroupModule { }
